import { IUseDialogData, useDialog } from 'modules/dialogs';
import { BTC_WALLET_CONNECT_DIALOG_ID } from '../const';

export const useBtcConnectionModal = (): IUseDialogData =>
  useDialog(BTC_WALLET_CONNECT_DIALOG_ID);
